import React from "react";

function Download() {
  return (
    <div className="container mx-auto flex flex-col bg-white p-10 rounded-xl lg:w-1/3 mt-4">
      <h2 className="text-xl font-bold">お仕事の依頼を検討中の方へ</h2>
      <p className="pt-4 font-normal">
        簡単な情報入力だけで、依頼の検討に役立つ資料を無料でダウンロードできます。
      </p>
      <p className="mt-4 text-xs text-gray-400">内容例</p>
      <ul className="list-disc ml-4 mb-6 text-xs text-gray-400">
        <li>クリエイターの過去の実績</li>
        <li>大まかな制作価格</li>
        <li>制作から納品までの流れ</li>
      </ul>
      <div class="border-b text-sm font-semibold text-gray-400 pb-1 mb-1">
        資料をダウンロード
      </div>

      <form
        action="https://docs.google.com/forms/u/0/d/e/1FAIpQLScfvkDvXIL4HFOr_ky2jSu7ZwRUwuikYHbeeJlPuQ2Pj1LtGg/formResponse"
        method="POST"
      >
        <div className="flex flex-col">
          <label className="text-xs font-bold mt-5 mb-2">お名前（必須）</label>
          <input
            name="entry.1643988053"
            className=" bg-slate-200 p-2 rounded-md"
            placeholder="姓 名"
            type="text"
            required="required"
            data-1p-ignore
            data-lpignore
          />

          <label className="text-xs font-bold mt-5 mb-2">
            メールアドレス（必須）
          </label>
          <input
            name="entry.131252725"
            className=" bg-slate-200 p-2 rounded-md"
            placeholder="username@example.com"
            type="email"
            required="required"
            data-1p-ignore
            data-lpignore
          />
          <p className="text-xs mt-1 text-gray-400"></p>
          <ul className="list-disc ml-4 mb-4 text-xs text-gray-400">
            <li>会社のメールアドレスを入力してください。</li>
            <li>
              入力いただいたメールアドレスに資料を自動返信にてお送りします。
            </li>
          </ul>

          <label className="text-xs font-bold mt-1 mb-2">会社名（必須）</label>
          <input
            name="entry.1772531344"
            className=" bg-slate-200 p-2 rounded-md"
            placeholder="Pixel株式会社"
            type="text"
            required="required"
            data-1p-ignore
            data-lpignore
          />
          <p className="text-xs mt-1 mb-2 text-gray-400">
            法人ではない方は「フリーランス」「個人事業」のように入力してください。
          </p>
        </div>
        <div className="flex flex-col mt-10 items-center">
          <button
            ctype="submit"
            class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            クリエイターの資料をダウンロード
          </button>
          <p className="text-xs my-3 text-gray-400">
            資料のダウンロードにあたり、
            <a href="/nda" className="underline text-blue-400" target="_blank">
              経済産業省が提供する秘密保持契約書をベースにした取扱規約
            </a>
            に同意したものとみなします。
          </p>
        </div>
      </form>
    </div>
  );
}

export default Download;
